import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { getHistoryByUser } from "../../services/searchImages/searchImageService";

interface ISearchState
{
  dataImages?: any;
  nextLink?: any | string;
  firstLink?: any | string;
  page?: any | number;
  isSearching: boolean;
  isFilter?: boolean;
  currentProviderCode?: string;
}

const initialState: ISearchState = {
  dataImages: [],
  nextLink: undefined,
  firstLink: undefined,
  page: 1,
  isSearching: false,
  isFilter: false,
};

export const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setCurrentProvider: (state, action: PayloadAction<string>) =>
    {
      state.currentProviderCode = action.payload;
    },
    // setDataImages: (state, action: PayloadAction<any>) =>
    // {
    //   state.dataImages = action.payload;
    // },

    setDataImages: (state, action: PayloadAction<any>) =>
    {
      const { code, data } = action.payload;

      //  nếu không phải provider hiện tại → bỏ
      // if (state.currentProviderCode !== code) return;

      state.dataImages = data;
    },

    setNextLink: (state, action: any) =>
    {
      state.nextLink = action.payload;
    },
    setFirstLink: (state, action: any) =>
    {
      state.firstLink = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) =>
    {
      state.page = action.payload;
    },
    setIsSearching: (state, action: PayloadAction<boolean>) =>
    {
      state.isSearching = action.payload;
    },
    setIsFilter: (state, action: PayloadAction<boolean>) =>
    {
      state.isFilter = action.payload;
    },
    setLoadingProvider: (state, action: PayloadAction<any>) =>
    {
      // @ts-ignore
      state[`loading_provider_${action.payload.code}`] = action.payload.value;
    },

    setDataImagesProvider: (state, action: PayloadAction<any>) =>
    {
      // @ts-ignore
      state[`loading_provider_${action.payload.code}`] = false;
      // @ts-ignore
      state[`data_images_${action.payload.code}`] = action.payload.data;
      // @ts-ignore
      state[`total_images_${action.payload.code}`] = action.payload.total;
      // @ts-ignore
      state[`page_${action.payload.code}`] = action.payload.page; // use next page
      // @ts-ignore
      state[`next_link_${action.payload.code}`] = action.payload.nextLink;
      // @ts-ignore
      state[`first_link_${action.payload.code}`] = action.payload.firstLink;
    },

    setTotalImagesProvider: (state, action: PayloadAction<any>) =>
    {
      // @ts-ignore
      state[`total_images_${action.payload.code}`] = action.payload.data;
    },

    resetProviderData: (state) =>
    {
      for (const key in state)
      {
        if (
          key.startsWith("loading_provider_") ||
          key.startsWith("data_images_") ||
          key.startsWith("total_images_")
        )
        {
          // @ts-ignore
          state[key] = undefined;
        }
      }
    },

    activeLoadingProvider: (state) =>
    {
      for (const key in state)
      {
        if (key.startsWith("loading_provider_"))
        {
          // @ts-ignore
          state[key] = false;
        }
      }
    },

    resetState: (state) =>
    {
      state.page = 1;
      state.firstLink = undefined;
      state.nextLink = undefined;
      state.dataImages = [];
      state.isSearching = false;
      state.isFilter = false;

      for (const key in state)
      {
        if (
          key.startsWith("loading_provider_") ||
          key.startsWith("data_images_") ||
          key.startsWith("total_images_")
        )
        {
          // @ts-ignore
          state[key] = undefined;
        }
      }
    },
  },
});

export const getHistoryByUserAsync = createAsyncThunk(
  "search/getHistoryByUser",
  async (payload: any) =>
  {
    try
    {
      const response = await getHistoryByUser(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const {
  setDataImages,
  setNextLink,
  setFirstLink,
  setPage,
  resetState,
  setIsSearching,
  setIsFilter,
  setLoadingProvider,
  setDataImagesProvider,
  setTotalImagesProvider,
  activeLoadingProvider,
  resetProviderData,
  setCurrentProvider
} = searchSlice.actions;

export default searchSlice.reducer;
